/*
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 15:33:25
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-10 13:52:44
 * @FilePath: \1008\zonghoutai-front\src\store\modules\user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


export default ({
  namespaced: true,
  state: {
    token:'',
    username:'',
    userId:'',
  },
  getters: {
  },
  mutations: {
    setToken(state,payload){
      state.token=payload
    },
    setUserName(state,payload){
        state.username=payload
    },
    setUserId(state,payload){
        state.userId=payload
    }
  },
  actions: {
  },
  modules: {
  }
})
